/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/fixed-return',
                    name: 'fixedReturn',
                    component: () => import('./views/Home.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: () => import('./views/Profile.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/plan/:id',
                    name: 'detail',
                    component: () => import('./views/Plan/detail.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/trust',
                    name: 'trust',
                    component: () => import('./views/Summery.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/Summery.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/credit-card',
                    name: 'credit card',
                    component: () => import('./views/CreditCard.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/cash-management',
                    name: 'cash-management',
                    component: () => import('./views/CashManagement.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/others-assets',
                    name: 'others-assets',
                    component: () => import('./views/OthersAssets.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/cash-management/:id',
                    name: 'cash-management-details',
                    component: () => import('./views/CashManagementDetails.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/notification',
                    name: 'notification',
                    component: () => import('./views/Notification.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/contact',
                    name: 'contact',
                    component: () => import('./views/Contact.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/customer',
                    name: 'customer',
                    component: () => import('./views/Customer/Customer.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/customer/:id',
                    name: 'customerDetail',
                    component: () => import('./views/Customer/Detail.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/account_staff',
                    name: 'accountStaff',
                    component: () => import('./views/User/Staff.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/account_customer',
                    name: 'accountCustomer',
                    component: () => import('./views/User/Customer.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/approval',
                    name: 'accountApproval',
                    component: () => import('./views/User/Approval.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/planTemplate',
                    name: 'planTemplate',
                    component: () => import('./views/PlanTemplate.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/dividend_approval',
                    name: 'dividendApproval',
                    component: () => import('./views/DividendApproval.vue'),
                    props: true,
                    meta: {auth: true}
                },
                {
                    path: '/summary',
                    name: 'summary',
                    component: () => import('./views/Customer/Summary.vue'),
                    props: true,
                    meta: {auth: true}
                },
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/login',
                    name: 'pageLogin',
                    component: () => import('@/views/pages/Login.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'pageError404',
                    component: () => import('@/views/pages/Error404.vue')
                },
                {
                    path: '/pages/reset',
                    name: 'pageReset',
                    component: () => import('@/views/pages/reset.vue')
                },
                {
                    path: '/pages/reset_password',
                    name: 'pageResetPwd',
                    component: () => import('@/views/pages/resetPwd.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.beforeEach((to, from, next) => {
    //根据字段判断是否路由过滤
    if (to.matched.some(record => record.meta.auth)) {
        if (router.app.$cookies.get('login') == 'true' && router.app.$cookies.get('token')) {
            next()
        } else {
            next({
                path: '/pages/login',
            });
        }
    }else{
        next();
    }
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    const Stickedtooltips = document.querySelectorAll(".vs-tooltip");
    for (const tooltip of Stickedtooltips) {
        tooltip.remove();
    }

})


export default router
